const SHAPES = {
    poisoned: [
        ["M18 61 Q8 68 17 87 Q23 99 50 99 Q77 99 83 87 Q92 68 82 61 Z", "#242b24", "#55654b", 1],
        ["M16 62 Q50 49 84 62 Q83 72 50 73 Q17 72 16 62 Z", "#5fae27", "#b8ef69", 0.85],
        ["M18 66 Q50 78 82 66", "none", "#111b13", 1],
        ["M24 91 L20 100 M76 91 L80 100", "none", "#303b2c", 1]
    ],
    drunk: [
        ["M78 44 L89 44 Q101 45 99 62 Q97 78 79 78 L79 69 Q90 70 91 60 Q93 52 79 53 Z", "#e6c477", "#fff0ba", 0.85],
        ["M19 29 L79 29 L77 91 Q49 103 21 91 Z", "#ffe6a0", "#fff3cb", 0.22],
        ["M23 49 Q50 45 75 49 L73 87 Q49 97 25 87 Z", "#e5a51d", "#ffcd52", 0.48],
        ["M19 29 L21 91 Q49 103 77 91 L79 29 M30 40 L32 85 M68 40 L66 85", "none", "#ffe6a0", 0.9],
        ["M19 35 Q10 26 22 22 Q21 12 34 18 Q43 8 53 17 Q66 8 71 20 Q85 16 83 29 Q89 39 77 41 Q64 34 53 39 Q40 34 29 39 Z", "#fff3cf", "#ffe4a0", 0.95]
    ]
};
const BUBBLES = [
    [27, 70, 4, 0], [70, 74, 5, 0.12], [38, 64, 3, 0.24],
    [61, 67, 4, 0.36], [22, 79, 3, 0.48], [76, 63, 3, 0.6],
    [45, 77, 5, 0.72], [56, 73, 3, 0.84]
];
const clamp = (value) => Math.max(0, Math.min(1, value));
const opacityAt = (t) => Math.min(clamp(t / 0.15), clamp((1 - t) / 0.2));

export const conditionTokenStateAt = () => ({ x: 0, y: 0, rotate: 0, filter: "none" });

export function createConditionScene(document, kind) {
    const create = (tag, attributes) => {
        const node = document.createElementNS("http://www.w3.org/2000/svg", tag);
        Object.entries(attributes).forEach(([key, value]) => node.setAttribute(key, value));
        return node;
    };
    const svg = create("svg", {
        viewBox: "0 0 100 100", class: `condition-scene condition-scene--${kind}`, "aria-hidden": "true"
    });
    SHAPES[kind].forEach(([d, fill, stroke, opacity]) => {
        svg.append(create("path", { d, fill, stroke, opacity, "stroke-width": 2, "stroke-linejoin": "round" }));
    });
    BUBBLES.forEach(([cx, cy, r, delay]) => {
        const bubble = create("circle", {
            cx, cy, r, class: "condition-scene__bubble",
            fill: kind === "poisoned" ? "#86ed45" : "#ffdb69",
            stroke: kind === "poisoned" ? "#d0ff9a" : "#fff5c7", "stroke-width": 0.8
        });
        bubble.style.animationDelay = `${0.2 + delay}s`;
        svg.append(bubble);
    });
    return svg;
}

export function drawCondition(context, x, y, size, t, kind) {
    context.save();
    context.translate(x, y);
    context.scale(size / 100, size / 100);
    context.globalAlpha = opacityAt(t);
    context.translate(0, 8 * (1 - opacityAt(t)));
    context.lineWidth = 2;
    context.lineJoin = "round";
    SHAPES[kind].forEach(([d, fill, stroke, opacity]) => {
        context.save();
        context.globalAlpha *= opacity;
        const path = new Path2D(d);
        context.fillStyle = fill;
        context.strokeStyle = stroke;
        if (fill !== "none") {
            context.fill(path);
        }
        context.stroke(path);
        context.restore();
    });
    BUBBLES.forEach(([cx, cy, r, delay]) => {
        const progress = (t * 1.8 - 0.2 - delay) / 0.7;
        if (progress < 0 || progress > 1) {
            return;
        }
        context.save();
        context.globalAlpha *= Math.min(clamp(progress / 0.15), clamp((1 - progress) / 0.25));
        context.fillStyle = kind === "poisoned" ? "#86ed45" : "#ffdb69";
        context.strokeStyle = kind === "poisoned" ? "#d0ff9a" : "#fff5c7";
        context.lineWidth = 0.8;
        context.beginPath();
        context.arc(cx + Math.sin(progress * Math.PI * 2) * 2, cy - 38 * progress, r * (0.65 + 0.35 * progress), 0, Math.PI * 2);
        context.fill();
        context.stroke();
        context.restore();
    });
    context.restore();
}
